import React, { createContext, useContext, useState } from 'react';

const AssistancePanelContext = createContext();

/**
 * AssistancePanelProvider - Manages In-Flight Assistance panel expand/collapse state
 * Default: Closed on all screens - user toggles to open
 *
 * Also carries an optional "locate" payload so the same right-panel slot can
 * show a Cockpit Explorer locate (single control or multi-step) when the
 * user taps a checklist locate icon, instead of the normal fault search UI.
 */
export const AssistancePanelProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [locate, setLocate] = useState(null);

  const toggle = () => {
    setLocate(null);
    setIsOpen(prev => !prev);
  };
  const open = () => {
    setLocate(null);
    setIsOpen(true);
  };
  const close = () => {
    setIsOpen(false);
    setLocate(null);
  };
  const openLocate = (payload) => {
    setLocate(payload);
    setIsOpen(true);
  };
  const closeLocate = () => setLocate(null);

  return (
    <AssistancePanelContext.Provider value={{ isOpen, toggle, open, close, locate, openLocate, closeLocate }}>
      {children}
    </AssistancePanelContext.Provider>
  );
};

export const useAssistancePanel = () => {
  const context = useContext(AssistancePanelContext);
  if (!context) {
    throw new Error('useAssistancePanel must be used within an AssistancePanelProvider');
  }
  return context;
};

export default AssistancePanelContext;

